import styled from 'styled-components';

export const StyledMfaFormContainer = styled.div`
  font-family: ${props => props.theme.fonts.secondary};
  .ant-form-item .ant-form-item-label > label {
    font-family: ${props => props.theme.fonts.secondary};
  }
`;
